import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  title: "Smart Grid Infrastructure",
  category: "ENERGY",
  description: "Implementing advanced metering and distribution automation for high-capacity regional power networks.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-grid.png",
  href: "/ProjectPage"
}, {
  title: "Urban Water Systems",
  category: "UTILITIES",
  description: "Developing sustainable wastewater treatment and desalination plants for rapidly growing metropolitan areas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-water.png",
  href: "/ProjectPage"
}, {
  title: "Solar Energy Hub",
  category: "RENEWABLES",
  description: "Engineering large-scale photovoltaic arrays with integrated battery storage and power conversion solutions.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-solar.png",
  href: "/ProjectPage"
}, {
  title: "Automated Port Terminal",
  category: "LOGISTICS",
  description: "Designing AI-driven container handling systems to optimize throughput for global maritime trade routes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-port.png",
  href: "/ProjectPage"
}, {
  title: "High-Speed Rail Corridor",
  category: "TRANSPORT",
  description: "Constructing regional rail links featuring advanced signaling systems and seismic protection engineering.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-rail.png",
  href: "/ProjectPage"
}, {
  title: "Coastal Defense Wall",
  category: "CIVIL",
  description: "Building durable marine defenses to mitigate rising sea levels and protect vulnerable urban coastlines.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-marine.png",
  href: "/ProjectPage"
}, {
  title: "Digital City Backbone",
  category: "DIGITAL",
  description: "Laying the fiber-optic and 5G foundation necessary for next-generation smart city connectivity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-digital.png",
  href: "/ProjectPage"
}, {
  title: "Modular Structural Units",
  category: "CONSTRUCTION",
  description: "Manufacturing high-precision pre-fabricated structural components for rapid infrastructure deployment.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure-modular.png",
  href: "/ProjectPage"
}];
export default function ProjectsOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="34927" id="related-projects" ref={ref} className="bg-background py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mb-16 max-w-3xl transition-none ${isVisible ? "opacity-100 translate-y-0" : "opacity-100 translate-y-0"}`}>
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-foreground mb-6">
            Related Projects
          </h2>
          <p className="text-xl font-sans text-muted-foreground">
            Delivering precision-engineered solutions for the most complex infrastructure challenges across global sectors, from energy to digital connectivity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, i) => <div key={i} data-index={i} className={`transition-none ${isVisible ? "opacity-100 translate-y-0" : "opacity-100 translate-y-0"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Link to={project.href} className="block h-full group">
                <Card className="h-full border border-border bg-card shadow-[0_20px_40px_rgba(0,0,0,0.05)] rounded-none overflow-hidden relative transition-colors duration-300 ease-in-out group-hover:border-ring border-b-4 border-b-ring">
                  <div className="relative h-48 w-full overflow-hidden border-b border-border">
                    <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
                    <Badge variant="secondary" className="absolute top-4 right-4 font-mono text-xs tracking-wider border border-border bg-background text-foreground rounded-none px-3 py-1 shadow-none z-10">
                      {project.category}
                    </Badge>
                  </div>

                  <CardHeader className="pt-8 pb-2">
                    <CardTitle className="font-default text-2xl font-bold text-primary group-hover:text-ring transition-colors">
                      {project.title}
                    </CardTitle>
                  </CardHeader>

                  <CardContent>
                    <p className="font-sans text-muted-foreground leading-relaxed">
                      {project.description}
                    </p>
                  </CardContent>

                  <CardFooter className="mt-auto pt-4 pb-8">
                    <Button variant="link" className="p-0 h-auto font-bold text-primary group-hover:text-ring transition-colors">
                      View Details <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </CardFooter>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}